import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { firstValueFrom } from 'rxjs';
import { StaticRole } from '@markant-platform/shared/user/model';

export function AuthorizationRouteGuard(...roles: StaticRole[]): CanActivateFn {
  return async (): Promise<boolean | UrlTree> => {
    // inject required deps
    const router: Router = inject(Router);
    const authenticatedUserService: AuthenticatedUserService = inject(AuthenticatedUserService);
    const snackbarService: SnackbarService = inject(SnackbarService);

    const userRoles = await firstValueFrom(authenticatedUserService.getUserRoles());
    const allowedRoles: string[] = Object.values(roles);
    const hasMatchingRole = userRoles.some(({ name }) => allowedRoles.includes(name));

    if (!hasMatchingRole) {
      snackbarService.showErrorSnackbarWithTransloco('redirect.not-authorized-to-access-view');
      return router.parseUrl('/');
    }

    return true;
  };
}
